/* eslint-disable no-redeclare */
/* eslint-disable eqeqeq */
import style from './YearHistoryMake.module.css';
import gstyle from '../../../css/GeneralStyle.module.css';
import React, {useState, useEffect} from 'react';
import axios from "axios";
import * as useJwt  from '../../../auth/jwt/useJwt.js';
import jwtDefaultConfig from '../../../auth/jwt/jwtDefaultConfig';
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ClipLoader from 'react-spinners/ClipLoader';
import IconSearch from '../../../components/common/icons/icon_search.png';
import InputDatepicker2 from '../../../components/common/input/InputDatepicker2';
import $ from 'jquery';
import NewWindow from 'react-new-window';
import ReactPaginate from 'react-paginate';
import "./pagenation.css";
import ReactToPrint from "react-to-print";
import { CSVLink, CSVDownload } from "react-csv";
import icon_warning from '../../../components/common/icons/icon_warning.png'; 


const YearHistoryMake = () => {

    const authentication = useJwt.isUserLoggedIn();
    const userData = JSON.parse(useJwt.getUserData());
    const menuPatternData = JSON.parse(useJwt.getMenuPatternData());
    const navigate = useNavigate();
    const [loaded, setLoaded] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showModalDel, setShowModalDel] = useState(false);
    const [showModalDel2, setShowModalDel2] = useState(false);
    const [opened, setOpend] = useState(false);

    const csloading = (flag) => {
        if(flag) {
            document.getElementById('csloader').style.display="flex";
        }else{
            document.getElementById('csloader').style.display="none";
        }
    } 
    
    // save date -----------------------------------------------
    const [SaveDate, setSaveDate] = useState(useJwt.formatDate(new Date()));
    const handleChangeSaveDate = (date) => {
        setSaveDate(useJwt.formatDate(date));
    };
    // コメント -----------------------------------------------
    const [HistoryComment, setHistoryComment] = useState("");
    const handleChangeHistoryComment = (event) => {
        setHistoryComment(useJwt.validateString(event.target.value,40));
    };
    // パスワード -----------------------------------------------
    const [password, setPassword] = useState("");
    const handleChangePassword = (event) => {
        setPassword(event.target.value);
    };
    const getPreviousPeriod = (date) => {
        let tdate = new Date(date);
        const previous = new Date(tdate.getTime());
        previous.setMonth(tdate.getMonth() - 1);
        let p_end_date = useJwt.formatYearMonth(previous);
        previous.setFullYear(tdate.getFullYear() - 1);
        previous.setMonth(tdate.getMonth() - 2);
        let p_start_date = useJwt.formatYearMonth(previous);
        return p_start_date + "度 ~ " + p_end_date + "度";
    }
    // =================================================================================

    useEffect(() => {
        if(authentication !== true)
			navigate("/login");
        if(!loaded) {
            setLoaded(true);
            if(menuPatternData['menu_carried_over_flag_2'] == 0 && userData['sys_role_id'] != 10000) {
                navigate("/");
            }
        }
	});
    // ================================= New Window ====================================
    const OpenSearchWindow = (event) => {
        event.preventDefault();
    }
    const CloseSearchWidow =()=> {
        setOpend(false);
    }

    const [mainTableData, setMainTableData] = useState([]);

    const gridMainTable = (result) => {
        setMainTableData(result);
        if(result.length>0){
            setOpend(true);
        }
    }
    // ========================== starts code for search ===============================
    const [TargetParam, setTargetParam] = useState(1);
    // ========================== print =================================================
    const componentRef = React.useRef(null);
    const onBeforeGetContentResolve = React.useRef(null);
    const [loading, setLoading] = React.useState(false);
    const [text, setText] = React.useState("old boring text");

    const handleAfterPrint = React.useCallback(() => {
        // console.log("`onAfterPrint` called");
    }, []);

    const handleBeforePrint = React.useCallback(() => {
        // console.log("`onBeforePrint` called");
        CloseSearchWidow();
    }, []);

    const handleOnBeforeGetContent = React.useCallback( () => {
        // console.log("`onBeforeGetContent` called");
        setLoading(true);
        setText("Loading new text...");
        return new Promise((resolve) => {
            onBeforeGetContentResolve.current = resolve;
            setTimeout(() => {
                setLoading(false);
                setText("New, Updated Text!");
                resolve();
            }, 1000);
        });
    }, [setLoading, setText]);

    React.useEffect(() => {
        if ( text === "New, Updated Text!" &&  typeof onBeforeGetContentResolve.current === "function" ) {
            onBeforeGetContentResolve.current();
        }
    }, [onBeforeGetContentResolve.current, text]);

    const reactToPrintContent = React.useCallback(() => {
        return componentRef.current;
    }, [componentRef.current]);

    const reactToPrintTrigger = React.useCallback(() => {
        return <button className={style.btn_print}>ﾌﾟﾘﾝﾀ</button>;
    }, []);
    // ========================== style =================================================
    // style array
    const style_row = [gstyle.cs_row];
    const style_col_12 = [gstyle.cs_col, gstyle.cs_col_12];
    const style_col_9 = [gstyle.cs_col, gstyle.cs_col_9];
    const style_col_8 = [gstyle.cs_col, gstyle.cs_col_8];
    const style_col_6 = [gstyle.cs_col, gstyle.cs_col_6];
    const style_col_4 = [gstyle.cs_col, gstyle.cs_col_4];
    const style_col_3 = [gstyle.cs_col, gstyle.cs_col_3];
    const style_col_2 = [gstyle.cs_col, gstyle.cs_col_2];
    const style_label_wrap = [gstyle.cs_label, gstyle.cs_flex_2];
    const style_input_wrap = [gstyle.p0015];
    const style_input_wrap2 = [style.p2030];
    const style_input_wrap3 = [style.grp_print_wrap];
    const style_input_wrap4 = [gstyle.p00300015];
    const style_input_100px = [gstyle.cs_input, gstyle.w100px];
    const style_date_wrap = [gstyle.cs_flex, gstyle.cs_date_wrap];

    return (
        <div className={gstyle.display}>
            <div className={gstyle.loader_container} id="csloader">
                <ClipLoader color={'#fff'} size={60} />
            </div>
            <ToastContainer />
            <input type={'hidden'} id="selectedId" />
            <div className={gstyle.border}>
                <p className={gstyle.text}>年次履歴作成処理</p>
            </div>
            <div className={gstyle.filed}>
                <div className={gstyle.cs_card_1}>
                    
                    {/* 保存月度 */}
                    <div className={style_row.join(" ")}>
                        <div className={style_col_2.join(" ")}></div>
                        <div className={style_col_3.join(" ")}>
                            <div className={style_input_wrap.join(" ")}>
                                <label className={style_label_wrap.join(" ")}>
                                    <span className={gstyle.cs_span}>保存月度</span>
                                    <div className={style_date_wrap.join(" ")}>
                                        <InputDatepicker2  value={SaveDate} onChange={handleChangeSaveDate} />
                                    </div>
                                </label>
                            </div>
                        </div>
                    </div>
                    {/* コメント */}
                    <div className={style_row.join(" ")}>
                        <div className={style_col_2.join(" ")}></div>
                        <div className={style_col_4.join(" ")}>
                            <div className={style_input_wrap.join(" ")}>
                                <label className={style_label_wrap.join(" ")}>
                                    <span className={gstyle.cs_span}>コメント</span>
                                    <div className={gstyle.cs_flex}>
                                        <textarea className={style.cs_textarea} value={HistoryComment}
                                        onChange={handleChangeHistoryComment} />
                                    </div>
                                </label>
                            </div>
                        </div>
                    </div>
                    {/* パスワード */}
                    <div className={style_row.join(" ")}>
                        <div className={style_col_2.join(" ")}></div>
                        <div className={style_col_4.join(" ")}>
                            <div className={style_input_wrap.join(" ")}>
                                <label className={style_label_wrap.join(" ")}>
                                    <span className={gstyle.cs_span}>パスワード</span>
                                    <div className={gstyle.cs_flex}>
                                        <input type={'password'} className={gstyle.cs_input} value={password}
                                        onChange={handleChangePassword} />
                                    </div>
                                </label>
                            </div>
                        </div>
                    </div>
                    {/* Summary */}
                    <div className={style_row.join(" ")}>
                        <div className={style_col_2.join(" ")}></div>
                        <div className={style_col_8.join(" ")}>
                            <div className={style_input_wrap.join(" ")}>
                                <div className={style.summary_wrap}>
                                    <div>
                                        <div className={style.summary_title_wrap}>
                                            <span className={style.summary_title_span}>年次履歴作成処理</span>
                                        </div>
                                        <p>この処理は 
                                            <span className={style.summary_b_txt_span}>
                                                {getPreviousPeriod(SaveDate)}
                                            </span> 
                                            のデータを、
                                            <span className={style.summary_b_txt_span}>
                                                {useJwt.formatYearMonth(new Date(SaveDate))}度データ
                                            </span>
                                            aaaaa コンピューター、aaaaaa
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    {/* button 設定 */}
                    <div className={gstyle.btn_update_wrap}>
                        <button className={gstyle.btn_update} onClick={OpenSearchWindow} >処理</button>
                    </div>
                </div>
            </div>
            {opened && (
            <NewWindow  onUnload={() => CloseSearchWidow()} 
                features={{ left: 30, top: 15, width: 1200, height: 700 }} >
                <div className={style.nw_container}>
                    <div ref={componentRef}>
                        <div className={style_row.join(" ")}>
                            <div className={style_col_12.join(" ")}>
                                <div className={style.nw_title_wrap}>
                                    <h2>年次履歴作成処理</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={style_row.join(" ")}>
                        <div className={style_col_12.join(" ")}>
                            <div className={style_input_wrap3.join(" ")}>
                                <ReactToPrint
                                    content={reactToPrintContent}
                                    documentTitle={'年次履歴作成処理_'+useJwt.formatDateTime(new Date())}
                                    onAfterPrint={handleAfterPrint}
                                    onBeforeGetContent={handleOnBeforeGetContent}
                                    onBeforePrint={handleBeforePrint}
                                    removeAfterPrint
                                    trigger={reactToPrintTrigger}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </NewWindow>
            )}
        </div>
    )
}

export default YearHistoryMake;